import { VisibilityOffTwoTone, VisibilityTwoTone } from '@mui/icons-material'
import { FormControl, FormHelperText, IconButton, InputAdornment, InputLabel, OutlinedInput } from '@mui/material'
import React from 'react'
import PropTypes from 'prop-types'

const PasswordField = ({ helperText, label, error, ...props }) => {
    const [showPassword, setShowPassword] = React.useState(false)

    const handleClickShowPassword = () => {
        setShowPassword((show) => !show)
    }

    const handleMouseDownPassword = (event) => { event.preventDefault() }

    return (
        <FormControl variant="outlined" fullWidth sx={{ my: 1 }} error={error}>
            <InputLabel htmlFor="outlined-password">{label}</InputLabel>
            <OutlinedInput
                id="outlined-password"
                type={showPassword ? 'text' : 'password'}
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                        >
                            {showPassword ? <VisibilityOffTwoTone /> : <VisibilityTwoTone />}
                        </IconButton>
                    </InputAdornment>
                }
                {...props}
            />
            {helperText && <FormHelperText error={error}>{helperText}</FormHelperText>}
        </FormControl>
    )
}

PasswordField.propTypes = {
    label: PropTypes.string.isRequired,
    error: PropTypes.bool,
    helperText: PropTypes.string,
}
PasswordField.defaultProps = {
    error: false,
    helperText: null,
}


export default PasswordField
